<miq-stepper #stepper>
  <!-- Step 1: Present the matched changes to user -->
  <cdk-step>
    <div class="dialog">
      <mat-icon
        *ngIf="!showSkipAndHideClose"
        class="dialog__close"
        aria-hidden="false"
        aria-label="Close icon"
        mat-dialog-close
        >close</mat-icon
      >
      <div mat-dialog-title l10nTranslate>
        {{ currentFlowData.dialogTitle }}
      </div>
      <div class="data-header">
        <div>
          <span class="bold-header">{{ currentFlowData?.mainHeader | xTranslate: { value: leaseCompId } }}</span
          >{{ currentFlowData.header | xTranslate: { value: leaseCompId, count: count } }}
        </div>
        <div l10nTranslate>
          {{ currentFlowData.noMatchUpdateManually || 'recordsSearch.noMatchUpdateManually' }}
        </div>
        <div class="space-size" *ngIf="spaceSizeChange">{{ spaceSizeChange | xTranslate }}</div>
      </div>
      <div mat-dialog-content>
        <div class="record-arrows" *ngIf="totalRecords > 1">
          <span l10nTranslate>shared.leaseComps</span>
          <span class="totalRecords">{{ currentIndex + ' / ' + totalRecords }}</span>
          <button (click)="swipe('left')" [disabled]="prevButtonDisabled">
            <mat-icon svgIcon="arrow-c-left"></mat-icon>
          </button>
          <button (click)="swipe('right')" [disabled]="nextButtonDisabled">
            <mat-icon svgIcon="arrow-c-right"></mat-icon>
          </button>
        </div>
        <div class="comparission-table">
          <miq-compare-common-fields
            *ngIf="commonRowData?.length > 0"
            [headerColumns]="currentFlowData.headerColumns"
            [(rowData)]="commonRowData"
            (rdChange)="updateValue($event)"
          >
          </miq-compare-common-fields>
          <ng-container *ngIf="perRecordData">
            <div *ngFor="let recordData of perRecordData">
              <miq-compare-common-fields
                [headerColumns]="currentFlowData.headerColumns"
                [rowData]="recordData"
              ></miq-compare-common-fields>
            </div>
          </ng-container>
        </div>
      </div>
      <div mat-dialog-actions>
        <button *ngIf="showSkipAndHideClose" mat-button color="primary" (click)="updateOrSkipClicked(false)">
          {{ 'recordsSearch.skip' | xTranslate | uppercase }}
        </button>
        <button mat-flat-button color="primary" (click)="updateOrSkipClicked(true)">
          {{ 'recordsSearch.update' | xTranslate | uppercase }}
        </button>
      </div>
    </div>
  </cdk-step>
  <!-- Step 2: Present the matched changes to user -->
  <cdk-step>
    <div class="loader-container">
      <div class="loading">
        <mat-spinner diameter="30"></mat-spinner>
        <span class="update" l10nTranslate>recordsSearch.updating</span>
      </div>
      <div class="second-message" l10nTranslate>shared.takingFewMinutes</div>
    </div>
  </cdk-step>
  <!-- Step 3: Confirmation -->
  <cdk-step>
    <div class="dialog">
      <div mat-dialog-title l10nTranslate>
        {{ errorOccurred ? 'shared.error' : 'shared.success' }}
      </div>
      <div mat-dialog-content>
        <div *ngIf="errorOccurred; else showMessage" class="errorinfo">
          <span>{{ 'recordsSearch.errorWhileSaving' | xTranslate }}</span>
        </div>
        <ng-template #showMessage>
          <div class="recordSave" l10nTranslate>core.saveChanges</div>
        </ng-template>
      </div>
      <div mat-dialog-actions>
        <button mat-flat-button color="primary" (click)="dialogRef.close()" l10nTranslate>shared.okGotIt</button>
      </div>
    </div>
  </cdk-step>
</miq-stepper>
